<template>
  <div class="form-group">
    <label class="col-form-label pt-0">{{ label }}</label>
    <div class="sugestao-wrapper">
      <ErroConexao
        v-if="erroConexao"
        class="alerta-registros" />

      <SemRegistros
        v-if="!erroConexao && sugestoes.length === 0 && !isLoading"
        :msgSemRegistros="msgSemRegistros"
        :rotaTelaCadastro="rotaTelaCadastro"
        class="alerta-registros" />

      <Autocomplete
        v-if="!isLoading && !erroConexao"
        v-model="valor"
        :items="itemsFiltrados"
        :component-item="template"
        :get-label="getLabel"
        :min-len="1"
        :wait="1"
        :input-attrs="{ class: this.retornaEstiloInput() }"
        :disabled="disabled"
        @input="input"
        @change="change"
        @update-items="updateItems" />

      <div
        class="invalid-msg"
        v-if="!campoComValorValido()">
        {{ retornaMensagemDeErro() }}
      </div>

      <Loader
        class="loader"
        v-if="isLoading && !erroConexao" />
    </div>
  </div>
</template>

<script>
import Autocomplete from 'v-autocomplete'
import 'v-autocomplete/dist/v-autocomplete.css'
import InputBaseMixins from '../mixins/InputBaseMixins'
import Loader from './Loader.vue'
import SemRegistros from './SemRegistros.vue'

import GeradorMensagens from '@/mixins/GeradorMensagens'

import ErroConexao from './ErroConexao.vue'

export default {
  name: 'InputAuto',
  mixins: [InputBaseMixins, GeradorMensagens],
  props: {
    template: {
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    sugestoes: {
      type: Array,
      default: function () {
        return []
      },
    },
    erroConexao: {
      type: Boolean,
      default: false,
    },
    msgSemRegistros: {
      type: String,
      default: '',
    },
    camposMostrarInput: {
      type: Array,
      default: function () {
        return []
      },
    },
    camposFiltrar: {
      type: Array,
      default: function () {
        return []
      },
    },
    separador: {
      type: String,
      default: ' ',
    },
    rotaTelaCadastro: {
      type: String,
      default: '',
    },
  },
  components: {
    Autocomplete,
    Loader,
    ErroConexao,
    SemRegistros,
  },
  data() {
    return {
      todosItens: [],
      itemsFiltrados: [],
    }
  },
  methods: {
    getLabel(item) {
      if (item) {
        return this.retornaCamposConcatenados(this.camposMostrarInput, item)
      }

      return ''
    },
    input(text) {
      if (!text) {
        this.itemsFiltrados = []
      }
    },
    change(text) {
      if (!text) {
        this.itemsFiltrados = []
      }
    },
    updateItems(text) {
      if (text) {
        const filtrados = this.sugestoes.filter(itemSugestao => {
          // eslint-disable-next-line
          const stringValidar = this.camposFiltrar.reduce((sum, campo) => {
            return `${sum} ${this.retornaCampoComDot(itemSugestao, campo)}`
          }, '')

          if (stringValidar) {
            return stringValidar.toLowerCase().includes(text.toLowerCase())
          }

          return false
        })

        this.itemsFiltrados = filtrados.slice(0, 10)
      }
    },
    campoComValorValido() {
      return this.verificaEstadoInput() !== false
    },
    retornaEstiloInput() {
      return !this.campoComValorValido()
        ? 'form-control is-invalid'
        : 'form-control'
    },
    possuiRegistros() {
      return (!this.isLoading && this.sugestoes.length > 0)
    },
    retornaCamposConcatenados(arrCampos, objeto) {
      return arrCampos.reduce((retorno, campo) => {
        const sep = retorno.length === 0
          ? ''
          : this.separador

        return `${retorno}${sep}${this.retornaCampoComDot(objeto, campo)}`
      }, '')
    },
    retornaCampoComDot(objeto, campoFiltro) {
      if (campoFiltro.includes('.')) {
        const campoPai = campoFiltro.slice(0, campoFiltro.indexOf('.'))
        const campoFilho = campoFiltro.slice(campoFiltro.indexOf('.') + 1, campoFiltro.length)

        return objeto[campoPai][campoFilho]
      }

      return objeto[campoFiltro]
    },
    abrirTelaCadastro() {
      this.$router.push({ name: this.rotaTelaCadastro })
    },
  },
}

</script>

<style lang="scss">
@import "@/scss/colors.scss";

.sugestao-wrapper {
  position: relative;
  min-height: calc(1.5em + 0.75rem + 2px);
}

.alerta-registros {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgb(220, 53, 69);
  padding: 0 0 0 0.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 0.25rem;
  z-index: 1;
}

.loader {
  position: absolute;
  top: 6px;
  left: 6px;
}

.invalid-msg {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}

.v-autocomplete-list {
  padding: .2rem;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  width: 100%;
  z-index: 10;
}

.v-autocomplete-list-item {
  padding: .2rem 0;
}

.v-autocomplete-list-item.v-autocomplete-item-active{
  background-color:$cor-azul !important;
  color: $cor-fonte-clara;
}

</style>
